/* eslint-disable max-len */
import { ReactElement, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import NavigationPage from '../../components/NavigationPage/NavigationPage';
import AnnouncementCard from '../../components/AnnouncementCard/AnnouncementCard';
import { fetchAnnouncementsByDocumentType } from 'src/redux/thunks/announcementsThunks';
import './HelpCenter.css';
import { abortPromiseOnUnmount } from 'src/services/base.service';
import { selectAnnouncements } from '../../redux/slices/announcementSlice';
import { AnnouncementDataModel } from 'src/types/propTypes/AnnouncementDataModel';
import { groupHelpCenterPanels } from './HelpCenterPanel';

const HelpCenter = (): ReactElement => {
  const dispatch = useAppDispatch();
  console.log("Getting announcementDataItems...");
  const announcementDataItems: AnnouncementDataModel[] = useAppSelector(
    selectAnnouncements  
  );
  const panels = groupHelpCenterPanels(announcementDataItems);

  useEffect(() => {
    const promise: unknown = dispatch(fetchAnnouncementsByDocumentType('Help Center'));
    return () => {
      abortPromiseOnUnmount(promise);
    };
  }, [dispatch]);

  useEffect(() => {
    console.log(groupHelpCenterPanels(announcementDataItems));
  }, [announcementDataItems]);

  return (
    <NavigationPage
      heading={'Help Center'}
      pageClass="help-center"
      isLoading={false}
    >
    <div className="help-center--directions">
      {panels.map((panel) => (
        <AnnouncementCard
          key={panel.panelTitle}
          panelTitle={panel.panelTitle}
          subpanels={panel.subPanels}
        />
      ))}
    </div>
    </NavigationPage>
  );
};

export default HelpCenter;
